import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8f9fc]">
        <div className="w-8 h-8 border-4 border-[#1a1f5e] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    const adminOnly = allowedRoles?.includes("admin") && !allowedRoles?.includes("recruiter");
    if (adminOnly) return <Navigate to="/admin/login" replace />;
    const recruiterOrAdmin = allowedRoles?.some(r => r === "recruiter");
    return <Navigate to={recruiterOrAdmin ? "/recruiter/login" : "/student/login"} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === "student") return <Navigate to="/student/dashboard" replace />;
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "recruiter") return <Navigate to="/recruiter/dashboard" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}
